import CopyInputAdornment from './CopyInputAdornment'

export * from './CopyInputAdornment'
export default CopyInputAdornment
